const LstCustom = {
    init: function (settings) {
        LstCustom.config = {
            aos: {
                enable: true
            },
        };

        LstCustom.setup();
    },

    setup: function () {
        LstCustom.setupAOS();
        LstCustom.registerEventHandlers();
    },

    setupAOS: function () {
        if (LstCustom.config.aos.enable) {
            AOS.init({
                duration: 450,
                anchorPlacement: 'top-bottom',
                once: false
            });
        }
    },

    registerEventHandlers: function () {

    }

};

document.addEventListener('DOMContentLoaded', function () {
    LstCustom.init();
});
